
module.exports = {
    key: "c0d573b18729da9019711dcbacf8458d",
    base: "https://api.openweathermap.org/data/2.5/",
  };
  